import { Component, Input } from '@angular/core';

import { SearchActivityEvents } from 'generated/graphql';

@Component({
  selector: 'app-remove-entity-event',
  templateUrl: './remove-entity-event.component.html'
})

export class ASRemoveEntityEventComponent  {

  @Input() item: SearchActivityEvents.Node;
  /**
   *
   */
  constructor(
  ) {
  }


}
